<template>
  <div>
    <b-row  class="match-height">
      <b-col lg="3" md="12">
        <b-card no-body v-if="$can('create', 'Nominas')">
          <b-card-body>
            <validation-observer ref="simpleRules">
              <form
                  ref="registrar"
                  autocomplete="off"
              >
                <b-row>
                  <b-col md="12">
                    <b-form-group
                        label="Empresa"
                        label-for="empresa"
                        invalid-feedback="Seleccione empresa"
                    >
                      <v-select
                          class="select-size-sm"
                          id="empresa"
                          v-model="empresaSeleccion"
                          :options="empresas"
                          :reduce="empresas => empresas.id"
                          label="nombre"
                          key="id"
                          placeholder="Seleccionar empresa..."
                          required
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                        label="Cuenta"
                        label-for="tipo"
                    >
                      <v-select
                          class="select-size-sm"
                          id="tipo"
                          @input="cambiarEstadoTipo2"
                          v-model="tipoEmpleadoSelect"
                          :options="tipoEmpleado"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                        label="Tipo"
                        label-for="tipo2"
                    >
                      <v-select
                          class="select-size-sm"
                          id="tipo2"
                          v-model="tipoEmpleadoSelect2"
                          :options="tipoEmpleado2"
                          :disabled="estadoTipo2"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                        label="Valor"
                        label-for="valor"
                        invalid-feedback="Valor es requerido"
                    >
                      <validation-provider
                          #default="{ errors }"
                          rules="required|regex:^\d+(\.\d)?\d*$"
                          name="Valor"
                      >
                        <b-form-input
                            size="sm"
                            id="valor"
                            placeholder="Valor"
                            v-model="valorMoneda"
                            :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                        label="Semana"
                        label-for="semana"
                        invalid-feedback="Semana es requerido"
                    >
                      <validation-provider
                          #default="{ errors }"
                          rules="required|integer|max:2"
                          name="Semana"
                      >
                        <b-form-input
                            size="sm"
                            id="semana"
                            v-model="semana"
                            :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                        :state="validacion"
                        label=''
                        label-for="enviar"
                    >
                      <b-button
                          size="sm"
                          id="enviar"
                          variant="primary"
                          type="submit"
                          block
                          @click.stop.prevent="enviarFormulario(1)"
                      >
                        Registrar
                      </b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
              </form>
            </validation-observer>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="9" md="12">
        <b-card no-body v-if="$can('read', 'Nominas')">
          <b-card-body>
            <b-row  class="match-height">
              <b-col lg="1" md="6">
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                >
                  <b-button
                      block
                      v-if="$can('read', 'Nominas')"
                      variant="gradient-primary"
                      size="sm"
                      @click="traerEmpresas"
                  >
                    <feather-icon
                        icon="RefreshCwIcon"
                    />
                  </b-button>
                </b-form-group>
              </b-col>
              <b-col lg="5" md="6">
                <v-select
                    class="select-size-sm"
                    id="empresa2"
                    v-model="empresaSeleccionFiltro"
                    :options="empresas"
                    :reduce="empresas => empresas.id"
                    label="nombre"
                    key="id"
                    placeholder="Empresa..."
                    required
                    @input="filtrarResultados"
                />
              </b-col>
              <b-col lg="2" md="6">
                <v-select
                    class="select-size-sm"
                    id="semana2"
                    v-model="semanaSeleccionFiltro"
                    :options="semanasFiltro"
                    placeholder="Semana..."
                    required
                    @input="filtrarResultados"
                />
              </b-col>
              <b-col lg="4" md="6">
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                        id="filterInput"
                        v-model="filter"
                        type="search"
                        placeholder="Buscar"
                    />
                    <b-input-group-append>
                      <b-button
                          :disabled="!filter"
                          @click="filter = ''"
                      >
                        Borrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
          <b-table
              size="sm"
              hover
              responsive
              class="position-relative"
              :per-page="perPage"
              :current-page="currentPage"
              :fields="fields"
              :items="nominasFiltro"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="cPaginacion"
          >
            <template #cell(estado)="data">
              <b-badge :variant="status[1][data.value]">
                {{ status[0][data.value] }}
              </b-badge>
            </template>

            <template #cell(tipo)="data">
          <span class="text-nowrap" v-if="data.value === ''">
            --
          </span>
              <span class="text-nowrap" v-else>
            {{ data.value }}
          </span>
            </template>

            <template #cell(valor)="data">
          <span class="text-nowrap">
            S/ {{ data.value }}
          </span>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">
                <feather-icon
                    v-if="$can('update', 'Nominas')"
                    :id="`btn_${data.item.id}_editar`"
                    icon="EditIcon"
                    size="16"
                    class="mx-1"
                    @click="mostrarModal(data.item.id)"
                />
                <b-tooltip
                    title="Editar registro"
                    :target="`btn_${data.item.id}_editar`"
                />
                <feather-icon
                    v-if="$can('delete', 'Nominas')"
                    :id="`btn_${data.item.id}_eliminar`"
                    icon="Trash2Icon"
                    size="16"
                    @click="eliminarRegistro(data.item.id, data.item.cod)"
                />
                <b-tooltip
                    title="Eliminar registro"
                    :target="`btn_${data.item.id}_eliminar`"
                />
              </div>
            </template>
          </b-table>
          <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
            <!-- page length -->
            <b-form-group
                label="Mostrar"
                label-cols="5"
                label-align="left"
                label-size="sm"
                label-for="sortBySelect"
                class="text-nowrap mb-md-0 mr-1"
            >
              <b-form-select
                  id="perPageSelect2"
                  v-model="perPage"
                  size="sm"
                  inline
                  :options="pageOptions"
              />

            </b-form-group>

            <!-- pagination -->
            <div>
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mb-0"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
        id="modalRegistro"
        v-model="estadoModal"
        title="Editar Registro"
        ok-title="Editar"
        cancel-variant="outline-secondary"
        cancel-title="Cancelar"
        @hidden="resetModal"
        @ok="enviarFormulario(2)"
        centered
    >
      <validation-observer ref="simpleRulesE">
        <form
            ref="registrar"
            autocomplete="off"
        >
          <b-row>
            <b-col md="12">
              <b-form-group
                  label="Empresa"
                  label-for="empresaE"
                  invalid-feedback="Seleccione empresa"
              >
                <v-select
                    id="empresaE"
                    v-model="empresaSeleccion"
                    :options="empresas"
                    :reduce="empresas => empresas.id"
                    label="nombre"
                    key="id"
                    placeholder="Seleccionar empresa..."
                    required
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                  label="Cuenta"
                  label-for="tipoE"
              >
                <v-select
                    id="tipoE"
                    @input="cambiarEstadoTipo2"
                    v-model="tipoEmpleadoSelect"
                    :options="tipoEmpleado"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                  label="Tipo"
                  label-for="tipo2E"
              >
                <v-select
                    id="tipo2E"
                    v-model="tipoEmpleadoSelect2"
                    :options="tipoEmpleado2"
                    :disabled="estadoTipo2"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                  label="Valor"
                  label-for="valorE"
                  invalid-feedback="Valor es requerido"
              >
                <validation-provider
                    #default="{ errors }"
                    rules="required|regex:^\d+(\.\d)?\d*$"
                    name="Valor"
                >
                  <b-form-input
                      id="valorE"
                      placeholder="Valor"
                      v-model="valorMoneda"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                  label="Semana"
                  label-for="semanaE"
                  invalid-feedback="Semana es requerido"
              >
                <validation-provider
                    #default="{ errors }"
                    rules="required|integer|max:2"
                    name="Semana"
                >
                  <b-form-input
                      id="semanaE"
                      v-model="semana"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                  label="Estado"
                  label-for="estado"
                  invalid-feedback="Código AGV es requerido"
              >
                <v-select
                    id="estado"
                    v-model="estado"
                    :options="estados"
                    :reduce="estados => estados.value"
                    label="text"
                    key="value"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import axiosIns from '../../libs/axios'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  required, integer, max
} from '@validations'

import { BCard, BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BTooltip, BModal, VBModal, BListGroup, BListGroupItem, BRow, BCol
} from 'bootstrap-vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [5, 10, 15],
      totalRows: 0,
      currentPage: 1,
      sortBy: 'id',
      sortDesc: true,
      sortDirection: 'desc',
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'empresa',
          label: 'Empresa',
          sortable: true
        },
        {
          key: 'cuenta',
          label: 'Cuenta',
          sortable: true
        },
        {
          key: 'tipo',
          label: 'Tipo',
          sortable: true
        },
        {
          key: 'valor',
          label: 'Valor',
          sortable: true
        },
        {
          key: 'semana',
          label: 'Semana',
          sortable: true
        },
        {
          key: 'estado',
          label: 'Estado',
          sortable: true
        },
        {
          key: 'acciones'
        },
      ],
      empresas: [],
      semanasFiltro: [],
      nominas: [],
      nominasFiltro: [],
      empresaSeleccion: null,
      empresaSeleccionFiltro: 0,
      semanaSeleccionFiltro: null,
      tipoEmpleado: ["Empleado", "Obrero"],
      tipoEmpleadoSelect: "Empleado",
      tipoEmpleado2: ["", "Planilla", "AFP", "Plame"],
      tipoEmpleadoSelect2: "",
      estadoTipo2: true,
      valorMoneda:  null,
      semana:  null,
      status: [
        {
          0: 'Activo',
          1: 'Inactivo',
        },
        {
          0: 'light-success',
          1: 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: 0, text: "Activo"},
        {value: 1, text: "Inactivo"}
      ],
      estado: 0,
      id: 0,
      estadoModal: false,
      required,
      integer,
      max
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.traerEmpresas();
    localize("es")
  },
  methods: {
    traerEmpresas(){
      var yo = this

      var config = {
        method: 'get',
        url: '/utilidades/empresas_ss/'
      };

      axiosIns(config)
          .then(function (response) {
            yo.empresas = response.data;
            yo.nominas = []
            yo.semanasFiltro = []

            for (let value of yo.empresas){
              for (let value2 of value.susa){
                yo.nominas.push({"id": value2.id, "id_empresa": value.id, "empresa": value.nombre, "cuenta": value2.cuenta, "tipo": value2.tipo, "valor": value2.valor, "semana": value2.semana, "estado": value2.estado})
                yo.semanasFiltro.push(value2.semana)
              }
            }

            yo.semanasFiltro = [... new Set(yo.semanasFiltro)];

            yo.totalRows = yo.nominas.length
            yo.nominasFiltro = yo.nominas
          })
          .catch(function (error) {
            console.log(error);
          });

      this.resetModal()
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    enviarFormulario(tipo) {

      var yo = this
      var estad = tipo === 1 ? this.$refs.simpleRules : this.$refs.simpleRulesE

      estad.validate().then(success => {
        if (success) {

            var data = JSON.stringify({
              "cod": "SSA",
              "cuenta": yo.tipoEmpleadoSelect,
              "tipo": yo.tipoEmpleadoSelect2,
              "valor": yo.valorMoneda,
              "semana": yo.semana,
              "empresa": yo.empresaSeleccion,
              "estado": yo.estado
            });

            var url = tipo === 1 ? '/utilidades/nominas/crear/' : '/utilidades/nominas/editar/' + this.id
            var metodo = tipo === 1 ? 'post' : 'patch'

            var config = {
              method: metodo,
              url: url,
              headers: {
                'Content-Type': 'application/json'
              },
              data: data
            };

            axiosIns(config)
                .then(function (response) {

                  if (response.status === 201 || response.status === 200) {
                    yo.traerEmpresas();

                    if (tipo === 1) {
                      yo.mostrarNotificacion('Registro creado', 'CheckIcon', 'El registro ha sido registrado correctamente', 'success')
                    } else {
                      yo.mostrarNotificacion('Registro modificado', 'CheckIcon', 'El registro ha sido modificado correctamente', 'success')
                    }

                  } else {
                    yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                  }

                })
                .catch(function (error) {
                  console.log(error);
                  yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
                });

          estad.reset()
        }
      })


    },

    cambiarEstadoTipo2(){
      this.estadoTipo2 = this.tipoEmpleadoSelect === 'Empleado'
      this.tipoEmpleadoSelect2 = this.estadoTipo2 ? null : "Planilla"
    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: 5000
          })
    },

    resetModal() {
      this.empresaSeleccion = 2
      this.tipoEmpleadoSelect = 'Empleado'
      this.tipoEmpleadoSelect2 = null
      this.valorMoneda = null
      this.semana = null
      this.estado = 0
      this.estadoModal = false
      this.id = 0
      this.estadoTipo2 = true
      this.empresaSeleccionFiltro = null
      this.semanaSeleccionFiltro = null

      this.$refs.simpleRules.reset()
      //this.$refs.simpleRulesE.reset()
    },

    mostrarModal(id){
      this.id = id

      for ( let value of this.nominasFiltro){
        if( value.id === id ){
          this.empresaSeleccion = value.id_empresa
          this.tipoEmpleadoSelect = value.cuenta
          this.tipoEmpleadoSelect2 = value.tipo
          this.semana = value.semana
          this.valorMoneda = value.valor
          this.estado = parseInt(value.estado)
        }
      }

      this.estadoTipo2 = this.tipoEmpleadoSelect === 'Empleado'

      this.estadoModal = !this.estadoModal

    },

    eliminarRegistro(id){
      var yo = this

      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres eliminar este registro?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          var config = {
            method: 'delete',
            url: '/utilidades/nominas/eliminar/' + id,
            headers: { }
          };

          axiosIns(config)
              .then(function (response) {
                if (response.status === 204){
                  yo.traerEmpresas();
                  yo.mostrarNotificacion('Registro eliminado', 'CheckIcon', 'El registro ha sido eliminado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                }
              })
              .catch(function (error) {
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
              });
        }
      })
    },

    filtrarResultados(){
      var spd = []
      if(this.semanaSeleccionFiltro === null && this.empresaSeleccionFiltro !== null){
        for (let value of this.nominas){
          if (value.id_empresa === this.empresaSeleccionFiltro){
            spd.push({"id": value.id, "id_empresa": value.id_empresa, "empresa": value.empresa, "cuenta": value.cuenta, "tipo": value.tipo, "valor": value.valor, "semana": value.semana, "estado": value.estado})
          }
        }
      }else if(this.semanaSeleccionFiltro !== null && this.empresaSeleccionFiltro === null){
        for (let value of this.nominas){
          if (value.semana === this.semanaSeleccionFiltro){
            spd.push({"id": value.id, "id_empresa": value.id_empresa, "empresa": value.empresa, "cuenta": value.cuenta, "tipo": value.tipo, "valor": value.valor, "semana": value.semana, "estado": value.estado})
          }
        }
      }else if(this.semanaSeleccionFiltro !== null && this.empresaSeleccionFiltro !== null){
        for (let value of this.nominas){
          if (value.semana === this.semanaSeleccionFiltro && value.id_empresa === this.empresaSeleccionFiltro){
            spd.push({"id": value.id, "id_empresa": value.id_empresa, "empresa": value.empresa, "cuenta": value.cuenta, "tipo": value.tipo, "valor": value.valor, "semana": value.semana, "estado": value.estado})
          }
        }
      }else {
        spd = this.nominas
      }

      this.totalRows = spd.length
      this.nominasFiltro = spd


    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
